import React from 'react'
import { Box, Button, Grid, Stack } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { ResponseModel } from 'model/utilModels/ResponseModel';
import { PaginatorModel } from 'model/utilModels/PaginatorModel';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { FinancialProtectionService } from 'services/menu/financialProtection/FinancialProtectionService'
import { FinancialProtectionModel } from 'model/screensModels/FinancialProtectionModel';
import { msgTypes } from 'constants/msgTypes';
import { Formik, Form } from 'formik'
import FormikControl from 'components/wrapperComponents/FormikControl';
import CustomTableGrid from 'components/uiComponents/CustomTableGrid';
import ApiUrl from 'services/shared/ApiUrl';
import { Switch } from "@mui/material";
import { conformationAlert } from 'services/shared/alert';
import { FinancialProtectionSchema } from 'schemas/menu/financialProtection/FinancialProtectionSchema';
import Tooltip from '@mui/material/Tooltip';
import DispalyImage from 'components/wrapperComponents/DispalyImage';

export const FinancialProtectionList = ({ setFlag, updateRecord, loadRecentGuideline }) => {
  const [financialList, setFinancialList] =  useState<ResponseModel | null>(null); 
  const paginatorModel: PaginatorModel = new PaginatorModel();
  const [pagination, setPagination] = useState({
    pageSize: paginatorModel.pageSize,
    pageNumber: paginatorModel.pageNumber,
    filter: "",
    orderBy: "",
    desc: "",
  })

  const columns = useMemo(() =>
    [
      {
        accessorKey: "financialProtectionHeading",
        header: "Heading",
        size: 150
      },
      {
        accessorKey: "financialProtectionMessage",
        header: "Financial Protection Message",
        size: 150
      },
      {
        header: 'attachment',
        Cell: ({ renderedCellValue, row }) => (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {/* <img alt="avatar" height={35} width={35} src={row.original.attachment ? ApiUrl.fileBaseUrl + row.original.attachment + "/" : "/image/userimage.jpg"} loading="lazy" /> */}
            < DispalyImage
                  imageUrl={row.original?.attachment}
                  imageSize={msgTypes.IMAGE_SIZE.SMALL} />
          </Box>
        ),
        size: 50
      },
      {
        accessorKey: "status",
        header: "Status",
        size: 50,
        Cell: ({ cell, row }) => (
          <Switch
            name="status"
            checked={row?.original?.status}
            onChange={() => {
              updateStatus(row.original)
            }}
          />
        ),
      },
      {
        header: 'Action',
        Cell: ({ renderedCellValue, row }) => (
          <div className='d-flex'>
            {/* <EditIcon onClick={()=>{editRecord(row.original)}} color='primary'/>
              <DeleteIcon onClick={()=>{deleteRecord(row.original)}} color='error' /> */}
            <Tooltip title="Edit">
              <EditIcon fontSize="small" onClick={() => { editRecord(row.original) }} />
            </Tooltip>
            <Tooltip title="Delete">
              <DeleteIcon fontSize="small" onClick={() => { deleteRecord(row.original) }} />
            </Tooltip>
          </div>
        ),
        size: 10,
        grow: false,
      },

    ], []);

  useEffect(() => {
    getFinancialList();
  }, [pagination.pageNumber, pagination.pageSize, pagination.filter, pagination.orderBy, pagination.desc])

  //End:: UseEffect Hooks 

  //Prepare request body to get blog list
  const prepareRequest = () => {
    const requestBody = new PaginatorModel();
    requestBody.pageNumber = pagination.pageNumber;
    requestBody.pageSize = pagination.pageSize;
    requestBody.filter = pagination.filter;
    requestBody.orderBy = pagination.orderBy;
    requestBody.desc = pagination.desc;
    return requestBody;
  }

  //Get Financial Protection list
  const getFinancialList = async () => {
    const requestBody = prepareRequest();
    const res = await FinancialProtectionService.getFinancialList(requestBody);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setFinancialList(res);
      //setBlogList(undefined)
    }
  }

  //Open Form To edit Record
  const editRecord = (record: FinancialProtectionModel) => {
    updateRecord(record);
    setFlag(true)
  }

  const deleteRecord = async (record: FinancialProtectionModel) => {
    const requestData: FinancialProtectionModel = new FinancialProtectionModel();
    requestData.financialProtectionId = record.financialProtectionId

    const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR, "delete");

    // const deleteFlag = await conformationAlert(msgTypes.CONFORMATION_MESSAGE.DELETE_RECORD, msgTypes.CONFORMATION_ICON.ERROR);
    if (deleteFlag) {
      const res = await FinancialProtectionService.deleteFinancial(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getFinancialList();
        loadRecentGuideline();
      }
    }
  }

  const initialValues = {}
  const onSubmit = () => {
    getFinancialList();
  }


  const updateStatus = async (record: FinancialProtectionModel) => {
    const requestData: FinancialProtectionModel = new FinancialProtectionModel();
    requestData.financialProtectionId = record.financialProtectionId;
    requestData.financialProtectionMessage = record.financialProtectionMessage ? record.financialProtectionMessage : '';
    requestData.attachment = record.attachment ? record.attachment : '';
    requestData.financialProtectionHeading = record.financialProtectionHeading ? record.financialProtectionHeading : '';
    if (record.status) {
      requestData.status = false;
    } else {
      requestData.status = true;
    }


    const updateStatusFlag = await conformationAlert(
      msgTypes.CONFORMATION_MESSAGE.UPDATE_RECORD,
      msgTypes.CONFORMATION_ICON.WARNING,
      "Yes! Update"
    );
    if (updateStatusFlag) {
      // const res = await FinancialProtectionService.updateFinancialStatus(
      const res = await FinancialProtectionService.addFinancialProtection(requestData);
      if (res.statusMsg === msgTypes.SUCCESS.msg) {
        getFinancialList();
      }
    }
  };


  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={FinancialProtectionSchema}
      onSubmit={onSubmit}
    >
      {
        formik =>
        (
          <Form>
              {financialList ? (
            <CustomTableGrid
              item={
                <FormikControl
                  control='materialTable'
                  tableColumn={columns}
                  tableData={financialList}
                  //formikValue={formik}
                  setPagination={setPagination}
                // actions={[{ type: "icon", icon: <EditIcon/>, actionFunc: editRecord },
                //   { type: "icon", icon: <DeleteIcon color='error' />, actionFunc: deleteRecord }
                // ]}
                />
              }
            />
          ) : null}
          </Form>
        )
      }
    </Formik>
  )
}
